import Button from '@mui/material/Button'
import { styled } from '@mui/material'
import Grid2 from '@mui/material/Grid2'
import KeyboardHideIcon from '@mui/icons-material/KeyboardHide'
import BackspaceIcon from '@mui/icons-material/Backspace'

const KeyboardButton = styled(Button)(({ theme }) => ({
  background: '#FFFFFF',
  color: '#000000',
  
  [`@media (orientation: portrait)`]: {
    [theme.breakpoints.down('md')]: {
      margin: '3px',
      padding: '1px',
      fontSize: '2rem'
    },
    [theme.breakpoints.up('md')]: {
      margin: '3px',
      padding: '8px',
      fontSize: '2rem'
    }
  },

  [`@media (orientation: landscape)`]: {
    [`@media (max-height: 850px)`]: {
      margin: '3px',
      padding: '1px',
      fontSize: '2rem'
    },
    [`@media (min-height: 851px)`]: {
      margin: '3px',
      padding: '8px',
      fontSize: '2rem'
    }
  }
}))

const SpecialButtons = styled(KeyboardButton)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    width: '132px'
  },
  [theme.breakpoints.up('md')]: {
    width: '135px'
  }
}))

const OkButton = styled(SpecialButtons)({
  background: '#0098d8',
  color: '#FFFF'
})

interface KeyboardKeyProps {
  onKeyPress: (key: string) => void
}

const KeyboardKeys = ({ onKeyPress }: KeyboardKeyProps) => {
  const keyboardLayout = [
    ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'delete'],
    ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', 'å'],
    ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', 'ä', 'ö'],
    ['down', 'z', 'x', 'c', 'v', 'b', 'n', 'm', 'OK']
  ]

  const handleKeyPress = (key: string) => () => onKeyPress(key)

  return (
    <>
      {keyboardLayout.map((row, rowIndex) => (
        <Grid2 container justifyContent="OK" key={rowIndex}>
          {row.map((key, index) => {
            const uniqueKey = `${rowIndex}-${index}`

            if (key === 'OK') {
              return (
                <OkButton key={uniqueKey} onClick={handleKeyPress(key)}>
                  {key}
                </OkButton>
              )
            } else if (key === 'down') {
              return (
                <SpecialButtons key={uniqueKey} onClick={handleKeyPress(key)}>
                  <KeyboardHideIcon sx={{ fontSize: 40 }} />
                </SpecialButtons>
              )
            } else {
              return (
                <KeyboardButton key={uniqueKey} onClick={handleKeyPress(key)}>
                  {key === 'delete' ? (
                    <BackspaceIcon sx={{ fontSize: 30 }} />
                  ) : (
                    key
                  )}
                </KeyboardButton>
              )
            }
          })}
        </Grid2>
      ))}
    </>
  )
}

export default KeyboardKeys
